var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CountTableChart',{attrs:{"name":"Category","items":_vm.items,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }